import { Pipe, PipeTransform } from '@angular/core';
import { EstimatorOption } from '@components/estimateur-etape/models';
import { BudgetEstimatorEstimate } from '@stores/models';

@Pipe({ name: 'estimateOptions' })
export class EstimateOptionsPipe implements PipeTransform {
  transform(budgetEstimate: BudgetEstimatorEstimate | null | undefined): EstimatorOption[] {
    if (!budgetEstimate) {
      return [];
    }

    const {
      styleSelected,
      layoutSelected,
      sizeSelected,
      workPlanSelected,
      sinkTypeSelected,
      householdApplianceSelected,
      installationSelected,
    } = budgetEstimate;

    const options = [
      styleSelected,
      layoutSelected,
      sizeSelected,
      workPlanSelected,
      sinkTypeSelected,
      ...(householdApplianceSelected ?? []),
      installationSelected,
    ];

    return options.filter((option): option is EstimatorOption => Boolean(option));
  }
}
